/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';



/**
 * Fonctions de test
 */
@Injectable({
  providedIn: 'root',
})
export class TestService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation testSendEmail
   */
  static readonly TestSendEmailPath = '/api/test/email';

  /**
   * Envoie un mail de test.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `testSendEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  testSendEmail$Response(params: {

    /**
     * Adresse email du destinataire
     */
    body: string
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, TestService.TestSendEmailPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Envoie un mail de test.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `testSendEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  testSendEmail(params: {

    /**
     * Adresse email du destinataire
     */
    body: string
  }): Observable<Blob> {

    return this.testSendEmail$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation testAddWebhookRequests
   */
  static readonly TestAddWebhookRequestsPath = '/api/test/webhook';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `testAddWebhookRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  testAddWebhookRequests$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, TestService.TestAddWebhookRequestsPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `testAddWebhookRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  testAddWebhookRequests(params?: {
  }): Observable<Blob> {

    return this.testAddWebhookRequests$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation testTestPubSub
   */
  static readonly TestTestPubSubPath = '/api/test/pubsub';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `testTestPubSub()` instead.
   *
   * This method doesn't expect any request body.
   */
  testTestPubSub$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, TestService.TestTestPubSubPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `testTestPubSub$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  testTestPubSub(params?: {
  }): Observable<Blob> {

    return this.testTestPubSub$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation testSendMessageEmail
   */
  static readonly TestSendMessageEmailPath = '/api/test/email-message';

  /**
   * Envoie un e-mail à l'adresse spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `testSendMessageEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  testSendMessageEmail$Response(params: {

    /**
     * Adresse du destinataire
     */
    recipient?: string;

    /**
     * Nom du destinataire
     */
    recipientName?: string;

    /**
     * Message à envoyer par e-mail
     */
    body: any
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, TestService.TestSendMessageEmailPath, 'post');
    if (params) {
      rb.query('recipient', params.recipient, {});
      rb.query('recipientName', params.recipientName, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Envoie un e-mail à l'adresse spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `testSendMessageEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  testSendMessageEmail(params: {

    /**
     * Adresse du destinataire
     */
    recipient?: string;

    /**
     * Nom du destinataire
     */
    recipientName?: string;

    /**
     * Message à envoyer par e-mail
     */
    body: any
  }): Observable<boolean> {

    return this.testSendMessageEmail$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

}
